import React, { Component } from 'react';
import { connect } from 'react-redux';
import '../../search/search.scss';
import { getRefData } from '../../../redux/actions/individual-user-flow/individual-user-flow-action';
import './bank-list-style.scss';
import PropTypes from 'prop-types';
import Styled from 'styled-components';
import toLower from 'lodash/toLower';
import COLORS from '../../../common/styles/color-pallete';
import { FONT_FAMILY } from '../../../common/styles/fontStyles';
import { CLOSE, SEARCH_ICON } from '@Images';

const fullWidth = `
width: 100%;
margin-bottom: 10px;
`;

const Container = Styled.div`
     height: 100%;
     ${(p) => p.maxWidth && `max-width: ${p.maxWidth}`};
     ${(p) => !p.singleRowField && 'margin-bottom: 16px'};
     ${(p) => p.isBranchRequiredCountry && fullWidth};
     @media only screen and (max-width: 1080px) {
        ${(p) => (p.maxWidth ? `max-width: ${p.maxWidth}` : 'width:325px')};
        margin-left: 8px;
        ${(p) => !p.singleRowField && 'margin-left: 0'};
    }
    .error{
        color: red;
    font-size: 0.68rem;
    margin-top: 0px;
    margin-left:12px;
    font-family: "Roboto","Helvetica","Arial",sans-serif;
    font-weight: 400;
    line-height: 1.66;
    }
`;
const OutlinedTextField = Styled.div`
    position: relative;  
    ${(p) => (p.maxWidth ? `max-width: ${p.maxWidth}` : 'max-width:325px')};
    display: flex;
    align-items: center;
  >label{
    position: absolute;
    font-size: 10px;
    font-family: 'hellix-regular';
    left: 0;
    top: -4px;
    background-color: white;
    color: ${(p) => (p.error ? '#f44336' : 'gray')};
    padding: 0 0.3rem;
    margin: 0 0.5rem;
    transition: .1s ease-out;
    transform-origin: left top;
    pointer-events: none;
  }
  >input {
  width: 100%;    
  font-size: 1rem;
  outline: none;
  border: ${(p) => (p.error ? `1px solid #f44336` : `1px solid #a9a9a9`)};
  border-radius: 5px;  
  padding: 1rem 0.7rem;
  color: ${COLORS.black};
  transition: 0.1s ease-out;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  &&&::placeholder{
      color:red;
  }
  padding-right: 15%;
}
input:focus {
  border-color: ${(p) => (p.error ? '#f44336' : COLORS.black)};
}
input:focus + label {
  color: ${(p) => (p.error ? '#f44336' : '#000')};
  top: 0;
  transform: translateY(-50%) scale(.9);
}
input::placeholder {
  font-family: 'hellix-regular';
  font-size: 14px;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.43;
  letter-spacing: normal;
  color: rgb(116, 124, 137);
  text-transform: none;
}
  @media only screen and (max-width: 800px) {
    ${(p) => (p.maxWidth ? `max-width: ${p.maxWidth}` : 'max-width:325px')};
    ${(p) => (p.isSingleRowField ? `width: 100%;` : 'width:325px')};
  }
`;

const InputPlace = Styled.input`
     &::placeholder {
       color: ${(p) => (p.$inputError ? '#f44336' : 'rgb(116, 124, 137)')} !important;
   }
`;
const Suggestion = Styled.div`
width:100%;
height: 200px;
position: absolute;
margin-top: 54px !important;
z-index: 10;
${(p) => (p.maxWidth ? `max-width: ${p.maxWidth}` : 'max-width: 325px')};
background: white;
border-radius: 4px;
border: 1px solid ${COLORS.lightestGrey};
box-shadow: 1px 2px 2px rgba(0, 0, 0, 0.03);
overflow-y: auto;
&::-webkit-scrollbar-track {
    background-color: transparent;
    -webkit-box-shadow: none;
    border-radius: 0px;
  }
  
  &::-webkit-scrollbar {
    width: 8px;
    height: 8px;
    background-color: transparent;
  }
  
  &::-webkit-scrollbar-thumb {
    border-radius: 20px;
    height: 50px;
    border: 2px solid;
    border-color: transparent;
    background-clip: padding-box;
    -webkit-border-radius: 20px;
    box-shadow:none;
    -webkit-box-shadow: none;
    background-color: ${COLORS.borderGrey};
  }
`;

const SuggestionItems = Styled.div`
    max-height: 50px;
    ${(p) => (p.maxWidth ? `max-width: ${p.maxWidth}` : 'width:100%')};
    text-align: left;
    padding: 13px 19px;
    cursor: pointer;
    display: flex;
    align-items: center;
    font-family: ${FONT_FAMILY.hellix.regular};
    word-break: break-word;
    line-height: 17px;
    &:hover{
        background-color: rgba(72, 249, 254, 0.4);
    }
`;

const CloseButton = Styled.button`
    border:none;
    display:flex;
    color: ${COLORS.black};
    cursor:pointer;
    background-color:transparent;
    margin-left: -10%;
`;
class BankListSGNew extends Component {
  constructor(props) {
    super(props);
    this.state = {
      search: '',
      loading: false,
      suggestions: null,
      suggestedBanks: null,
      hideList: true
    };
  }
  async componentDidMount() {
    document.addEventListener('mousedown', this.handleClick, false);
    await this.fetchData();
  }

  fetchData = async (url = this.props.url) => {
    const response = await this.props.getRefData(url);
    if (response && response.data && response.data.data && response.data.data.length !== 0) {
      await this.setState({ suggestions: response.data.data });
      const {
        input: { value }
      } = this.props;
      if (value) {
        await this.setState({ search: value });
        const { suggestions, search } = this.state;
        if (suggestions && suggestions.length !== 0 && search) {
          this.props.onBankNameChange(
            suggestions.filter((item) => toLower(item.value) === toLower(search))[0]
          );
        }
      }
    }
  };

  handleClick = (e) => {
    if (this.node && !this.node.contains(e.target)) this.setState({ hideList: true });
  };
  onSuggestionSelect = (item) => {
    this.setState({ search: item.value, hideList: true });
    this.props.onBankNameChange(item);
  };
  onSearchChange = async ({ target: { value } }) => {
    this.props.onBankNameChange();
    await this.setState({ search: value, hideList: false });
    const { search } = this.state;
    const suggestedBanks =
      this.state.suggestions &&
      this.state.suggestions.length !== 0 &&
      this.state.suggestions.filter((item) => {
        return item.value.toLowerCase().indexOf(search.toLowerCase()) !== -1;
      });
    await this.setState({ suggestedBanks });
  };

  renderIcon() {
    const { search, loading } = this.state;
    return loading ? (
      <div className="search-icon loading">&nbsp;</div>
    ) : (
      <img className="search-icon" alt="search" src={search ? CLOSE : SEARCH_ICON} />
    );
  }

  UNSAFE_componentWillReceiveProps = async (nextProps) => {
    if (nextProps.currency_code !== this.props.currency_code) {
      this.onClearBankName();
      await this.fetchData(nextProps.url);
    }
  };

  onClearBankName = async () => {
    await this.setState({ search: '' });
    this.props.onBankNameChange();
    this.props.onClearBankField();
  };
  render() {
    const { hideList, suggestedBanks, search } = this.state;
    const {
      meta: { touched, error },
      screen,
      maxWidth,
      isSingleRowField
    } = this.props;
    return (
      <>
        <Container isBranchRequiredCountry={this.props.isBranchRequiredCountry} maxWidth={maxWidth}>
          <OutlinedTextField
            error={touched && error}
            maxWidth={maxWidth}
            isSingleRowField={isSingleRowField}
          >
            {search && search.length !== 0 && <label>Bank name</label>}
            <InputPlace
              type="text"
              value={search}
              placeholder={'Bank name'}
              onChange={this.onSearchChange}
              $inputError={touched && error}
            />
            {search && search.length !== 0 && (
              <CloseButton onClick={this.onClearBankName} type="button">
                X
              </CloseButton>
            )}
          </OutlinedTextField>
          {touched && error && <p className="error">{error}</p>}
        </Container>
        {!hideList && (
          <Suggestion
            ref={(node) => (this.node = node)}
            screen={screen}
            maxWidth={maxWidth}
            isSingleRowField={isSingleRowField}
          >
            {suggestedBanks &&
              suggestedBanks.map((item, index) => {
                return (
                  <SuggestionItems
                    className="bank-suggestion"
                    key={index}
                    onClick={() => this.onSuggestionSelect(item)}
                    maxWidth={maxWidth}
                  >
                    {item.key}
                  </SuggestionItems>
                );
              })}
          </Suggestion>
        )}
      </>
    );
  }
}
BankListSGNew.propTypes = {
  getRefData: PropTypes.func,
  onBankNameChange: PropTypes.func,
  input: PropTypes.any,
  url: PropTypes.string,
  screen: PropTypes.any,
  showError: PropTypes.any,
  parentDispatch: PropTypes.any,
  formName: PropTypes.string,
  fieldName: PropTypes.string,
  bank_account_country: PropTypes.string,
  isBranchRequiredCountry: PropTypes.bool,
  meta: PropTypes.objectOf({
    error: PropTypes.string
  }),
  currency_code: PropTypes.string,
  onClearBankField: PropTypes.func,
  maxWidth: PropTypes.string,
  isSingleRowField: PropTypes.bool
};

export default connect(null, { getRefData })(BankListSGNew);
